module.exports = __webpack_public_path__ + "media/images/emblems/Sisikon-coat_of_arms-126b27b4d350971166c7c6566958ac0d.svg";